var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loading',{attrs:{"active":_vm.loading},on:{"update:active":function($event){_vm.loading=$event}}}),(_vm.isLogged)?_c('NavigationLogged'):_c('NavigationGuest'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }